export const GOOGLE_MAP_URL = `https://maps.googleapis.com/maps/api/js?key=${
  process.env.REACT_APP_GMAP_KEY
}&callback=initMap`;

export const DEFAULT_LOCATION = { lat: 20.5937, lng: 79.9629 };
export const DEFAULT_ZOOM = 12;

export const DEFAULT_MARKER = {
  scale: 17,
  // fillColor: "#A2A2A2",
  fillOpacity: 1,
  // strokeColor: "#000",
  strokeWeight: 1,
};

export const ACTIVE_MARKER = {
  scale: 17,
  fillColor: "#000",
  fillOpacity: 1,
  strokeColor: "#000",
  strokeWeight: 1,
};
export const MARKER_LABEL = {
  color: "#000",
  fontSize: "14px",
  fontWeight: "bold",
};

export const STREET_VIEW_SVGPATH =
  "M804.571 0c0-100.571-208.571-146.286-402.286-146.286s-402.286 45.714-402.286 146.286c0 77.714 116 114.286 213.143 130.857 20 3.429 38.857-9.714 42.286-29.714s-9.714-38.857-29.714-42.286c-117.714-20.571-150.857-52.571-152.571-59.429 5.714-19.429 115.429-72.571 329.143-72.571s323.429 53.143 329.143 73.714c-1.714 5.714-34.857 37.714-152.571 58.286-20 3.429-33.143 22.286-29.714 42.286s22.286 33.143 42.286 29.714c97.143-16.571 213.143-53.143 213.143-130.857zM585.143 512v-219.429c0-20-16.571-36.571-36.571-36.571h-36.571v-219.429c0-20-16.571-36.571-36.571-36.571h-146.286c-20 0-36.571 16.571-36.571 36.571v219.429h-36.571c-20 0-36.571 16.571-36.571 36.571v219.429c0 40.571 32.571 73.143 73.143 73.143h219.429c40.571 0 73.143-32.571 73.143-73.143zM530.286 731.428c0-70.857-57.143-128-128-128s-128 57.143-128 128 57.143 128 128 128 128-57.143 128-128z";



// WEBPACK FOOTER //
// ./src/component/GoogleMap/_config.js